// import { LegacyDocuments } from '../PrearrangementFragments';
import { buildTabDataFragment } from '../../../util/functions';
import gql from 'graphql-tag';

export default buildTabDataFragment(
    [
        gql`
            fragment PrearrangementSummaryFields on Prearrangement {
                ApplicantTitle
                ApplicantSurname
                ApplicantGivenName
                ApplicantMiddleName

                DoctorCode
                DoctorComment

                BillingNotes

                Enquiries {
                    #Atneed,Phone
                    ID
                    LegacyKey
                    EnquiryType
                    Funeral {
                        #Atneed
                        ID
                        LegacyKey
                    }
                }
                Quote {
                    #accepted
                    ID
                    Enquiry {
                        #Preneed
                        ID
                        LegacyKey
                        EnquiryType
                    }
                }
                Enquiry {
                    #Preneed
                    ID
                    LegacyKey
                    EnquiryType
                    Quotes {
                        ID
                        Accepted
                        Enquiry {
                            #Preneed
                            ID
                            LegacyKey
                            EnquiryType
                        }
                    }
                }
                LatestPrePlanForm {
                    ID
                }
            }
        `
        // LegacyDocuments
    ],
    'Prearrangement'
);
